export default __webpack_public_path__ + "static/media/facture_icon.88887b6f.svg";